import React from "react";
import PropTypes from "prop-types";
import Contributor from "../../../../../atoms/contributor";
import { humanizeDate } from "../../../../../utils/time-format";

import Icon from "../../../../../atoms/icon";
import { Link } from "@quintype/components";

import { isPremium } from "../../../../../../../isomorphic/data/story";
import assetify from "@quintype/framework/assetify";
import googlenews from "../../../../../../../assets/images/Vikatan_google_news_new.svg";
import appinstall from "../../../../../../../assets/images/install-app.png";

import styles from "./styles.m.css";
import SocialShareSection from "../../../../../atoms/social-share-section";

class StoryHeader extends React.Component {
  constructor(props) {
    super(props);

    this.dropdown = null;

    this.state = {
      dropdown: false,
      showRelativeTime: false
    };

    this.handleDropdownClick = this.handleDropdownClick.bind(this);
    this.handleExternalClick = this.handleExternalClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener("click", this.handleExternalClick);
    this.setState({ showRelativeTime: true });
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleExternalClick);
  }

  handleExternalClick(e) {
    this.setState({ dropdown: false });
  }

  handleDropdownClick = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    this.setState({ dropdown: !this.state.dropdown });
  };

  render() {
    const {
      story,
      renderSocialMedia = () => null,
      episodes,
      className,
      config,
      subheadline = true,
      readMore = true
    } = this.props;

    const uniqueIds = [];

    const uniqueEpisodes =
      episodes &&
      episodes.filter(episode => {
        const isDuplicate = uniqueIds.includes(episode.id);

        if (!isDuplicate) {
          uniqueIds.push(episode.id);

          return true;
        }

        return false;
      });

    return (
      <div className={`${styles["story-header"]} ${className}`}>
        {readMore === true && (
          <div className={styles["published-time-wrap"]}>
            {story["first-published-at"] && (
              <span className={styles["published"]}>
                Published:
                <time className={styles.time} dateTime={new Date(story["first-published-at"]).toISOString()}>
                  {humanizeDate(story["first-published-at"], this.state.showRelativeTime ? "relative" : "absolute")}
                </time>
              </span>
            )}
            {story["last-published-at"] && (
              <span className={styles["updated"]}>
                Updated:
                <time className={styles.time} dateTime={new Date(story["last-published-at"]).toISOString()}>
                  {humanizeDate(story["last-published-at"], this.state.showRelativeTime ? "relative" : "absolute")}
                </time>
              </span>
            )}
          </div>
        )}
        {!isPremium(story)}
        {story.headline && <h1 className={styles.headline}>{story.headline}</h1>}
        {readMore === true && story.authors && story.authors.length ? (
          <div className={styles.contributors}>
            <div className={styles.contributorOuter}>
              <SocialShareSection story={story} config={config} />
            </div>
            <div className="goog-vikatan-news">
              <div className="hidden-mobile">
                <a
                  href="https://news.google.com/publications/CAAqBwgKMJ6N_wow3fz3Ag?hl=ta&amp;gl=IN&amp;ceid=IN%3Ata"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.link}
                >
                  <img
                    src={assetify(googlenews)}
                    alt=""
                    className={styles["google-follow"]}
                    width="120px"
                    height="26px"
                  />
                </a>
              </div>
              <div className="hidden-desktop">
                <a
                  href="https://vikatanmobile.page.link/article_header"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.link}
                >
                  <img src={assetify(appinstall)} alt="" className={styles["appinstall"]} width="135" height="33" />
                </a>
              </div>
            </div>
          </div>
        ) : null}
        {readMore === true &&
          episodes && (
            <div className={styles["episode-dropdown-base"]}>
              <button
                aria-label="toggle dropdown"
                role="button"
                className={styles["selected-episode"]}
                onClick={this.handleDropdownClick}
                ref={element => {
                  this.dropdown = element;
                }}
              >
                <span className={styles["selected-episode-text"]}>{story.headline}</span>
                <Icon type={this.state.dropdown ? "angle-up" : "angle-down"} className={styles["dropdown-icon"]} />
              </button>
              <ul className={`${styles["episodes-dropdown"]} ${this.state.dropdown ? "" : "hidden"}`}>
                {uniqueEpisodes.map(episode => (
                  <li key={episode.id} className={styles.episode}>
                    <Link aria-label="Episode" href={episode.url} className={styles["episode-link"]}>
                      {episode.headline}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          )}
        {renderSocialMedia("show-mobile-and-tablet")}
        {story.subheadline && subheadline ? (
          <p className={`${styles["mobile-hide"]} ${styles["sub-headline"]}`}>{story.subheadline}</p>
        ) : null}
      </div>
    );
  }
}

StoryHeader.propTypes = {
  story: PropTypes.shape({
    "first-published-at": PropTypes.number,
    "last-published-at": PropTypes.number,
    headline: PropTypes.string,
    subheadline: PropTypes.string,
    contributor: PropTypes.shape(Contributor.propTypes)
  }),
  episodes: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.string,
      slug: PropTypes.string
    })
  ),
  renderSocialMedia: PropTypes.func,
  className: PropTypes.string,
  config: PropTypes.shape({
    cinemaMode: PropTypes.bool,
    disableAuthorLink: PropTypes.bool
  }),
  subheadline: PropTypes.bool,
  readMore: PropTypes.bool
};

export default StoryHeader;
